export default class BackPackStatisticalList {

    packedTime: Date;
    packedOrderNums: number;
    packedUserName: string;
}